import React, { useContext, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import NavBarAuth from '../../../../components/navbar/navbarAuth';
import { RxCrossCircled } from 'react-icons/rx';
import { BaseURL } from '../../../../Files/BaseURL';
import AlertContext from '../../../../Context/Alert/AlertContext';

function Final() {
  const [Name, setName] = useState('')
  const {id} = useParams()

  const alertContext = useContext(AlertContext);
  const { showAlert } = alertContext;

  const fetchName = async () => {
    try {
      const response = await fetch(`${BaseURL}/api/auth/getusername/${id}`);
      const data = await response.json();
      setName(data.FirstName);
    } catch (error) {
      showAlert(error.message, 'danger');
    }
  };
  useEffect(() => {
    fetchName();
  }, []);

  return (
    <>
      <NavBarAuth />
      <div className="bg-gray-100">
        <div className='w-[100%] h-2 bg-primarygreen rounded-r-full'>
        </div>
      </div>
      <div className="flex justify-center items-center bg-gray-100 py-20">
        <div className="mx-6 w-[95%] md:w-[60%] lg:w-[40%] bg-white p-8 rounded-lg shadow-md">
          <h2 className="text-2xl font-pop font-bold mb-4">Identity verification</h2>
          <p className="text-black font-pop text-lg mb-2">Thank you, {Name}! We’re just checking your details...</p>
          <p className="text-gray-600 font-pop mb-2">Our team verifies the information you provide. We will notify you via your email address when we have fully verified your information.</p>

          {/* <form> */}

          <div className="mb-4 flex gap-2 my-4">
            <div className="h-auto rounded-full bg-primarygreen w-1"></div>
            <div className="flex flex-col gap-2">
              <p className="text-black font-pop text-lg font-bold">Documents are being checked</p>
              <p className="text-gray-400 font-pop mb-2">It may take approximately 2 days</p>
            </div>
          </div>

            <Link to={'/signin'}>
          <button className="my-4 w-full bg-green-500 hover:bg-transparent  hover:bg-white-500 font-semibold hover:text-black font-pop text-xl py-3 px-4 border border-black-500 hover:border-green-500 rounded-full  text-white animate__animated animate__backInUp ">
              Go to Dashboard
          </button>
            </Link>
          {/* </form> */}
        </div>
      </div>
    </>
  );
}

export default Final;
